import React, { Component } from "react";
//import DateTime from "react-datetime";
import { DatePicker } from 'antd';
import { string, func, bool } from "prop-types";
import moment from "moment";

import "./datePicker.css";

class CPDatePicker extends Component {
  state = {
    isInvalid: false,
  };

  static propTypes = {
    onUpdate: func.isRequired,
    value: string,
    className: string,
		showTimePicker: bool.isRequired,
    dtFormat:string.isRequired,
  };

  onChange = (mdt, dtstring) => {
    const { onUpdate, showTimePicker , dtFormat} = this.props;
    if (moment.isMoment(mdt)) {

			if(!showTimePicker)
				mdt = mdt.startOf('day');

      this.setState(
        {
          ...this.state,
          isInvalid: false
        },
        onUpdate(mdt.format(dtFormat))
      );
    } else {
      this.setState(
        {
          ...this.state,
          isInvalid: true
        },
        onUpdate(mdt)
      );
    }
  };

	disabledDate(current) {
		// Can not select days after today
		return current && current > moment().endOf('day');
	}

  render() {
    const { value, className, showTimePicker } = this.props;
    // const { isInvalid } = this.state;
		//
    // let parsedValue = moment(value, dtFormat);
    // // if(parsedValue._isValid && !showTimePicker)
    // //   parsedValue.startOf('day');

    return (
      <div className={`cp-date-picker ${className}`}>
        <DatePicker
          defaultValue={moment(value)}
          format={`DD/MM/YYYY ${showTimePicker ? "HH:mm" : ""}`}
          showTime={{minuteStep:5, format: "HH:mm"}}
					disabledDate={this.disabledDate}
          onChange={this.onChange}
        />
        {/*<DateTime*/}
          {/*inputProps={{*/}
            {/*className: `form-control ${isInvalid ? "is-invalid" : ""}`*/}
          {/*}}*/}
         {/*defaultValue={parsedValue.isValid() ? parsedValue: value}*/}
         {/*// value={ parsedValue.isValid() ? parsedValue: value}*/}
          {/*onChange={this.onChange}*/}
          {/*dateFormat="DD/MM/YYYY"*/}
          {/*timeFormat={showTimePicker ? "HH:mm" : false}*/}
          {/*viewMode="days"*/}
        {/*/>*/}
      </div>
    );
  }
}

export default CPDatePicker;



// WEBPACK FOOTER //
// ./src/views/components/generic/date_picker_2/DatePicker.jsx